import React, { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import PropTypes from 'prop-types'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import useFontFamily from '@hooks/useFontFamily'
import useFontFamilies from '@hooks/useFontFamilies'

import FontFamilyListItem from '../FontFamilyListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

const PageContent = (props) => {
  const { pageFilters } = props

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredFontFamilies,
    filteredFontFamiliesCount,
    hasFilteredFontFamilies,
    loading,
  } = useFontFamilies({ filters: pageFilters, performHttpRequests: true })

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters, updateFilters,
    },
    defaultFilters,
  } = pageContext

  const {
    callbacks: { createOrEditFontFamily },
    urls: { fontFamiliesIndexUrl },
  } = useFontFamily()

  return (
    <>
      <Helmet>
        <title>Fonts | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" onClick={() => createOrEditFontFamily()} size="medium">
            Create
          </Button>
        )}
        activeTabBarItemKey="fonts"
        tabBarItems={[
          {
            href: fontFamiliesIndexUrl,
            icon: faGlobe,
            key: 'fonts',
            title: 'Fonts',
          },
        ]}
        title="System Fonts"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredFontFamilies && <ListBlankState />}

            {!loading && hasFilteredFontFamilies && (
              <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Fonts">
                <Box flexDirection="column">
                  {filteredFontFamilies.map(fontFamily => (
                    <FontFamilyListItem key={fontFamily.id} fontFamily={fontFamily} />
                  ))}
                </Box>

                <DashboardModule.LoadMoreFooter
                  callbacks={{ loadMore }}
                  canLoadMore={canLoadMore}
                  entityCount={filteredFontFamiliesCount}
                  loading={loading}
                />
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

PageContent.propTypes = {
  pageFilters: PropTypes.object.isRequired,
}

export default PageContent
